// Editorial scope only. Does not change simulator accounts, permissions or API visibility.
export const FOCUS_SIMULATOR_SLUG = "iracing";
export const FOCUS_EVENTS_HREF = "/eventos/simulador/iracing";
export const PUBLIC_STAGE_LINKS = [
  { label: "Inicio", href: "/", icon: "Home" },
  { label: "iRacing", href: FOCUS_EVENTS_HREF, icon: "CalendarDays" },
  { label: "Reglamento", href: "/reglamento", icon: "BookOpen" },
  { label: "Comunidades", href: "/comunidades", icon: "Users" },
  { label: "Tienda", href: "/tienda", icon: "ShoppingBag" },
  { label: "Sorteos", href: "/sorteos", icon: "Trophy" },
];
export const HIDDEN_STAGE_ROUTES = ["/equipos", "/tickets", "/overlays"];
